import { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authProvider } from '../auth';

function TelegramCallbackPage() {
  const { t } = useTranslation();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    const storedState = sessionStorage.getItem('telegram_oauth_state');
    sessionStorage.removeItem('telegram_oauth_state');

    if (!code || !state || state !== storedState) {
      setStatus('error');
      return;
    }

    const redirectUri = window.location.origin + '/telegram/callback';
    authProvider.telegramOAuthCallback(code, redirectUri, (ok) => {
      setStatus(ok ? 'success' : 'error');
    });
  }, []);

  if (status === 'success') return <Redirect to="/" />;

  if (status === 'error') {
    return (
      <div className="page-content">
        <div className="page-content-inner">
          <div className="uk-width-1-3@m m-auto my-5 uk-text-center">
            <p>{t('login.telegram_error')}</p>
            <a href="/login" className="btn btn-default">{t('login.back_to_login')}</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="page-content-inner uk-text-center">
        <div uk-spinner="ratio: 2" />
        <p className="mt-3">{t('login.telegram_loading')}</p>
      </div>
    </div>
  );
}

export default TelegramCallbackPage;
